export const integerAndGreaterThanZero = value => {
  let error = '';
  if (value && value <= 0 || value === 0) {
    error = 'Value must be greator than zero.';
  }
  if (value && value % 1 !== 0) {
    error = 'You must enter a whole number.';
  }
  return error;
};